export const CONFIRM_REMOVE_LIST_FROM_ACCOUNT_MODAL_ID =
  "confirm-remove-list-from-account-modal";
